<script setup lang="ts">
interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <div class="table-cell commission-bank-cell">
    <template v-if="props.data?.broker_profile?.bank_name">
      <h4 class="whitespace-nowrap">{{props.data?.broker_profile?.bank_name}} | {{props.data?.broker_profile?.bank_account_name}}</h4>
      <p>{{props.data?.broker_profile?.bank_account_number}}</p>
    </template>
  </div>
</template>

<style scoped>
.commission-bank-cell{
  display: flex;
  flex-direction: column;
  h4{
    font-weight: 500;
  }
  p{
    font-size: 12px;
    color: #b3b3b3;
  }
}
</style>
